import withParentSize from '@vx/responsive/lib/enhancers/withParentSize';
export default withParentSize;